{
  class stickyDiv extends HTMLElement {
    constructor(){
      super()
      this.loaded = false
    }

    connectedCallback() {
      if(this.loaded){
        return false
      } else {
        this.loaded = true
      }

      this.style.display = 'block'
      this.style.position = 'absolute'
      this.style.top = 0

      window.addEventListener('scroll', e => this._trigger())
      this._trigger()
    }

      
    _trigger(){
      const breakpoint = this.hasAttribute('breakpoint') ? parseInt(this.getAttribute('breakpoint')) : -1
      
      if(window.innerWidth <= breakpoint){
        this.style.position = ''
        this.style.width = ''
        this.style.top = ''
        this.style.bottom = ''
        return
      }

      const parentTop = this.parentNode.getBoundingClientRect().top + window.scrollY
      const parentBottom = parentTop + this.parentNode.offsetHeight
      const scroll = window.scrollY
      const parentPadding = parseFloat(window.getComputedStyle(this.parentNode).paddingLeft) + parseFloat(window.getComputedStyle(this.parentNode).paddingRight);      
      const parentWidth = this.parentNode.offsetWidth - parentPadding;

      // we are below scroll params
      if(this.offsetHeight + scroll >= parentBottom){
        this.style.position = 'absolute'
        this.style.top = ''
        this.style.bottom = 0
        this.style.width = parentWidth + 'px'
        return false
      }

      //we are within scroll params
      if(scroll > parentTop && scroll < parentBottom){
        this.style.position = 'fixed'
        this.style.top = 0
        this.style.bottom = ''
        this.style.width = parentWidth + 'px'
        return false
      }

      //we are above scroll params
      if(scroll < parentTop){
        this.style.position = 'absolute'
        this.style.top = 0  
        this.style.bottom = ''
        this.style.width = parentWidth + 'px'
        return false          
      }
    }
  }

  customElements.define("sticky-div", stickyDiv)
}